/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';

export const practiceAreaSchema: z.AnyZodObject = z.object({
  bullhornId: z.string().nullish(),
  id: z.string().uuid(),
  name: z.string().nullish(),
  parent: z.lazy(() => practiceAreaSchema).nullish(),
  parentId: z.string().uuid().nullish(),
  type: z.string().nullish(),
});

export type PracticeArea = z.infer<typeof practiceAreaSchema>;
